import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import './App.css';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Separate component to handle route animations dependent on location
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  // Initialize Theme State from LocalStorage or default to 'light'
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  // Effect to apply the theme to the HTML document and save to localStorage
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Function to toggle theme
  const toggleTheme = () => {
    setTheme((curr) => (curr === 'light' ? 'dark' : 'light'));
  };

  // FIX: Reveal the app only after it has mounted
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      setTimeout(() => {
        root.classList.add('loaded');
      }, 100);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Add ScrollToTop here inside Router so it has access to useLocation */}
        <ScrollToTop />
        
        {/* Pass theme and toggle function to Navbar */}
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        
        <AnimatedRoutes />
        
        <footer className="footer">
          <div className="container">
            <h3>
              <span style={{ color: 'var(--primary-gold)' }}>Valu<span style={{ color: 'var(--primary-red)' }}>Vant</span></span>
              {/* Force "Solutions" to be white in both Light and Dark modes */}
              <span style={{ color: '#ffffff' }}> Solutions</span>
            </h3>
            <p>&copy; {new Date().getFullYear()} ValuVant Solutions. All rights reserved.</p>
            <p><small><i>powered by ValuVant Solutions.</i></small></p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;